'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'hub-http/helpers/params';
import { isEmpty } from '../utils/object';
import Account from 'hub-pickers-lib/Accounts/records/Account';
import { redirectLink } from '../utils/links';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import * as colors from 'HubStyleTokens/colors';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class HubPickerRow extends Component {
  constructor(...args) {
    super(...args);
    this.getRedirectUrl = () => {
      const {
        redirectTo,
        query,
        account: {
          id,
          appDomain
        }
      } = this.props;
      let redirectUrl = redirectTo(id, appDomain);
      if (!isEmpty(query)) {
        redirectUrl += `${redirectUrl.indexOf('?') === -1 ? '?' : '&'}${stringify(query)}`;
      }
      return redirectUrl;
    };
    this.handleRowClick = e => {
      if (e.metaKey) {
        window.open(this.getRedirectUrl());
      } else {
        window.location = this.getRedirectUrl();
      }
    };
    this.onOpenButtonClick = e => {
      window.open(this.getRedirectUrl());
      e.stopPropagation();
    };
    this.onPinButtonClick = e => {
      this.props.onPinChange(this.props.account.id);
      e.stopPropagation();
    };
  }
  render() {
    const {
      account: {
        accountName,
        domain,
        id
      },
      pinned
    } = this.props;
    const accountNameOrId = accountName || id;
    return /*#__PURE__*/_jsxs("tr", {
      onClick: this.handleRowClick,
      children: [/*#__PURE__*/_jsxs(UITableHoverCell, {
        hoverContent: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(UIButton, {
            onClick: this.onPinButtonClick,
            size: "extra-small",
            use: "tertiary-light",
            children: pinned ? 'Unpin' : 'Pin'
          }), /*#__PURE__*/_jsxs(UIButton, {
            onClick: this.onOpenButtonClick,
            size: "extra-small",
            use: "tertiary-light",
            children: ["Open", /*#__PURE__*/_jsx(UIIcon, {
              name: "externalLink",
              alignment: "middle"
            })]
          })]
        }),
        children: [pinned && /*#__PURE__*/_jsx(UIIconCircle, {
          color: colors.OLAF,
          backgroundColor: colors.SORBET,
          legacy: true,
          name: "pin"
        }), /*#__PURE__*/_jsx("a", {
          href: this.getRedirectUrl(),
          "data-selenium": "portal-link",
          children: /*#__PURE__*/_jsx(UITruncateString, {
            className: pinned ? 'pinned' : '',
            children: accountNameOrId
          })
        })]
      }), /*#__PURE__*/_jsxs("td", {
        className: "domain",
        children: [/*#__PURE__*/_jsx(UITruncateString, {
          children: domain
        }), /*#__PURE__*/_jsx("span", {
          className: "subtext",
          children: id
        })]
      })]
    }, accountNameOrId);
  }
}
HubPickerRow.propTypes = {
  account: PropTypes.instanceOf(Account).isRequired,
  pinned: PropTypes.bool,
  onPinChange: PropTypes.func.isRequired,
  redirectTo: redirectLink.isRequired,
  query: PropTypes.object
};
export default HubPickerRow;